import { useRef, useState } from 'react';
import { getSectorsByBce } from '../api/digiscore-api';

export function useSectorsCache(token) {
  const cacheRef = useRef({});
  const [isLoading, setLoading] = useState(false);
  const [error, setError] = useState(undefined);

  async function ensureSectors(bce) {
    if (!bce) return [];
    const key = String(bce);
    if (cacheRef.current[key]) return cacheRef.current[key];

    try {
      setLoading(true);
      const data = await getSectorsByBce(key, token);
      cacheRef.current[key] = Array.isArray(data) ? data : [];
      return cacheRef.current[key];
    } catch (e) {
      console.error('[useSectorsCache] error:', e);
      setError(e);
      return [];
    } finally {
      setLoading(false);
    }
  }

  return {
    sectorsByBce: cacheRef.current,
    ensureSectors,
    isLoading,
    error
  };
}